import { useEffect, useRef, useState } from 'react';
import { SessionProvider, useSession } from 'next-auth/react'

import '../styles/globals.css'
import '../styles/globalVariables.scss'

import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../styles/customSlider.scss';
import { ToastContainer } from 'react-toastify';

import 'mapbox-gl/dist/mapbox-gl.css';

import 'react-toastify/dist/ReactToastify.css';
import { Chart, registerables } from "chart.js";
import { SocketProvider } from '../components/Context/socket';
import axios from 'axios';
import { useRouter } from 'next/router';
import { PacmanLoader } from 'react-spinners';
import Confetti from 'react-confetti';

import HomeLayout from '../components/Layouts/BrowserLayouts/HomeLayout/HomeLayout';

Chart.register(...registerables)

function MyApp({ Component, pageProps }) {

  const router = useRouter();

  useEffect(() => {
    async function openSocketServer() {
      await axios('/api/socketServer/socket')
    }

    openSocketServer();

  }, [])

  const [eventTicketPurchase, setEventTicketPurchase] = useState(null)

  useEffect(() => {
    if(router === null || router === undefined) return;
    if(router.query === null && router.query === undefined) return;
    if(router?.query?.purchase_Event !== undefined) {
      const getCheckoutID = router.query.purchase_Event;
      setEventTicketPurchase(getCheckoutID);
      router.replace({
        pathname: '/',
        query: null,
      }, undefined,
      { shallow: true });
    }
    if(router?.query?.adPurchaseCancelled !== undefined) {
      // Open Cancelled Ad Purchase Attempt
    }

  }, [router])

  const Layout = Component.Layout || HomeLayout;

  return (
      <SessionProvider>
        <SocketProvider>
          <Layout>

            <span style={{position: 'fixed', zIndex: 9999999999999}}><ToastContainer stacked position='center' /></span>

            {eventTicketPurchase !== null && <PurchaseContainer id={eventTicketPurchase} close={() => setEventTicketPurchase(null)} /> }

            <Component {...pageProps} />

          </Layout>
        </SocketProvider>
      </SessionProvider>
  )

}

const PurchaseContainer = ({ id, close }) => {

  const { data: session, status } = useSession();

  const router = useRouter();

  const [loading, setLoading] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    if(id === null || id === undefined) return;
    if(session === null || session === undefined) return;
    if(loading !== null) return;

    async function getCheckoutData() {
      setLoading(true);
      const result = await axios.post(`${window.location.origin}/api/eventHub/tickets/getTicketPurchase`, {
        id: session.user.token.id,
        checkoutID: id
      }).catch((error) => {
          if(error?.response?.data?.status !== undefined) {
              errorMsg(error?.response?.data?.status);
              setLoading(false);
          } else {
              errorMsg(error);
              setLoading(false);
          }
      })

      if(result !== undefined) {
        if(result.status === 200) {
            setLoading(false);
            setData(result.data);
        } else {
            errorMsg('There was a problem retrieving your ad account, please try again later.');
            setLoading(false);
        }
      }
    }

    getCheckoutData();

  }, [id, session])

  const containerRef = useRef(null);

  const [confettiActive, setConfettiActive] = useState(false);

  useEffect(() => {
    if(confettiActive === true) return;
    setConfettiActive(true);
  }, [])

  function handleRedirect() {
    if(status === 'loading') return;
    if(status === 'authenticated') {
      router.query.account = 'eventAccount';
      router.push(router);
    }
    if(status === 'unauthenticated') {
      router.push('/account/register');
    }
    close();
  }

  return (
    <section ref={containerRef} id='adPurchased'>
      {
        data === null ?
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <PacmanLoader size={40} color='#154734' />
        </div>
        :
        <>
          {confettiActive && (
            <Confetti
              width={window.innerWidth}
              height={window.innerHeight}
              recycle={false}
              gravity={1.5}
              numberOfPieces={200}
              run={confettiActive}
            />
          )}
          <div>
            <h1>Your purchase was successful 🎉</h1>
            <p>Thank you {data.name} for your purchase with Waco Exchange. If you have any questions, please contact us: contact@wacoexchange.com</p>
            <hr></hr>
            <h2>Purchase Details</h2>
            <div>
              <h1>Purchaser Name</h1>
              <h2>{data.name}</h2>
            </div>
            <div>
              <h1>Purchaser Email</h1>
              <h2>{data.email}</h2>
            </div>
            <div>
              <h1>Purchase Total:</h1>
              <h2>${data.purchaseTotal}</h2>
            </div>
            <span>
              <button onClick={close}>Close</button>
              <button onClick={handleRedirect}>My Tickets</button>
            </span>

          </div>
        </>
      }

    </section>
  )
}

export default MyApp
